"use client"
import styled from "@emotion/styled"
import { SVGProps } from "react"

const StyledBox = styled.div<{ color?: string }>`
  display: flex;
  padding: 2px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  background: ${(props) => (props.color ? props.color : "black")};
`
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={8}
    viewBox="0 0 8 8"
    fill="none"
    {...props}
  >
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.55}
      d="m6.6665 2-3.667 3.6665L1.333 4"
    />
  </svg>
)
const CheckedCheckboxTransparentIcon = ({ color }: { color?: string }) => (
  <StyledBox color={color}>
    <SvgComponent />
  </StyledBox>
)
export default CheckedCheckboxTransparentIcon
